import React from 'react';

const Timeline = () => {
    return (
        <div className="timeline section_sm bg_image_5">
            <div className="container">
                <div className="office_schedule">
                    <img src="images/border_top.png" alt="" />
                    <div className="office_schedule_inner">
                        <h6>Openning Hours</h6>
                        <ul>
                            <li>
                                <span className="day">Sunday</span>
                                <span className="time">8.00-23.00</span>
                            </li>
                            <li>
                                <span className="day">Monday</span>
                                <span className="time">8.00-23.00</span>
                            </li>
                            <li>
                                <span className="day">Tuesday</span>
                                <span className="time">8.00-23.00</span>
                            </li>
                            <li>
                                <span className="day">Wednesday</span>
                                <span className="time">8.00-23.00</span>
                            </li>
                            <li>
                                <span className="day">Thursday</span>
                                <span className="time">8.00-23.00</span>
                            </li>
                            <li>
                                <span className="day">Friday, Saturday</span>
                                <span className="time close">Closed</span>
                            </li>
                        </ul>
                    </div>
                    <img src="images/border_bottom.png" alt="" />
                </div>
            </div>
        </div>
    );
};

export default Timeline;